import { PRODUCTS_ACTIONS_TYPES } from "./products.types";

import { createAction } from "../../utils/reducer/reducer";
import { setSellers } from "../sellers/sellers.action";
import { SELLERS_ACTIONS_TYPES } from "../sellers/sellers.types";


export const setProducts = (products) => {
	return createAction(PRODUCTS_ACTIONS_TYPES.SET_PRODUCTS, products);
};

export const updateProds = (product) => {
	return (dispatch, getState) => {
		const state = getState()
		const { products: { products } } = state
		const arrayToUpdate = products[product.model]
		const newArr = arrayToUpdate.map((obj) => obj.pk === product.pk ? product : obj)


		const newState = {
			...state.products.products,
			[product.model]: newArr // Correctly update the array for the specific model
		};
		dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_PRODUCTS, newState))
	}
}

export const setKitPending = (kitData) => {
	return createAction(PRODUCTS_ACTIONS_TYPES.SET_KIT, kitData);
};

// Thunk Action
export const setSellersKits = (kitData) => {
	return (dispatch, getState) => {
		// Access the current state
		const state = getState();

		// Log for debugging
		const currentProds = state.products.sellersKits
		if (currentProds.length === 0) {
			currentProds.push(kitData)
			dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, currentProds));
		} else {
			const updatedArray = currentProds.filter((data) => data.user.id !== kitData.user.id)
			const newArr = [...updatedArray, kitData]

			dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
		}
		// Perform your logic to update the kit data

		// Dispatch the action with the updated kit data
	};
};

export const updateSellersKits = (kitData, seller) => {
	return (dispatch, getState) => {
		// Access the current state
		const state = getState();

		// Log for debugging
		const currentProds = state.products.sellersKits.filter((data) => data.user.id === seller.id)
		const currentProdsToEdit = state.products.sellersKits.filter((data) => data.user.id !== seller.id)
		const newObs = kitData?.observacao

		if (currentProds.length === 0) {
			console.log('not find userKit')
		} else {
			// console.log('currentKits:', currentProds)
			const updatedKits = currentProds[0].kits.map((kit) => {
				// console.log('kit: ', kit)
				// console.log('kitPK data', kitData)
				return kit.kit_pk === kitData.id
					? { ...kit, kit_observacao: newObs } // Update the matching kit
					: kit // Keep the other kits unchanged
			}
			);
			const currentUser = currentProds[0].user

			const newSellerArray = {
				user: currentUser,
				kits: updatedKits
			}

			// dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
			// const updatedArray = currentProds.filter((data) => data.user.id !== kitData.user.id)
			const newArr = [...currentProdsToEdit, newSellerArray]
			dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
		}
		// Perform your logic to update the kit data

		// Dispatch the action with the updated kit data
	};
};

export const deleteProdSellersKits = (kitData, prodToRemove) => {
	return (dispatch, getState) => {
		const state = getState();
		console.log('deletando item do KITTTTTTT', kitData, prodToRemove);

		// Localiza o item correto com base no kit
		const currentProdsToUpdate = state.products.sellersKits.find(data =>
			data.kits.some(kit => kit.kit_pk === kitData.kit_pk)
		);

		const currentProdsToKeep = state.products.sellersKits.filter(data =>
			!data.kits.some(kit => kit.kit_pk === kitData.kit_pk)
		);

		if (!currentProdsToUpdate) {
			console.log('not find userKit');
			return;
		}

		const currentUser = currentProdsToUpdate.user;

		const updatedKits = currentProdsToUpdate.kits.map((kit) => {
			if (kit.kit_pk === kitData.kit_pk || kit.kit_pk === kitData.id) {
				console.log('vai remover o kit aqui: ', kit.kit_products);

				// Garante que temos o ID correto
				const prodToRemoveId =
					typeof prodToRemove === 'object' ? prodToRemove.pk_kit_product : prodToRemove;

				// Atualiza os produtos do kit
				const updatedProducts = kit.kit_products
					.map((prod) => {
						if (prod.pk_kit_product === prodToRemoveId) {
							if (prod.quantity > 1) {
								return {
									...prod,
									quantity: prod.quantity - 1,
								};
							} else {
								// Remove o item
								return null;
							}
						}
						return prod;
					})
					.filter(Boolean); // remove os nulls

				return {
					...kit,
					kit_products: updatedProducts,
				};
			}
			return kit;
		});

		const newSellerArray = {
			user: currentUser,
			kits: updatedKits,
		};

		const newArr = [...currentProdsToKeep, newSellerArray];

		dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
	};
};

export const updateSellersKitsDeliveredInfo = (kitData, seller, is_delivered) => {
	return (dispatch, getState) => {
		// Access the current state
		const state = getState();

		// Log for debugging
		const currentProds = state.products.sellersKits.filter((data) => data.user.id === seller.user.id)
		const currentProdsToEdit = state.products.sellersKits.filter((data) => data.user.id !== seller.user.id)

		if (currentProds.length === 0) {
			console.log('not find userKit')
		} else {
			// console.log('currentKits:', currentProds)
			const updatedKits = currentProds[0].kits.map((kit) => {
				return kit.kit_pk === kitData.kit_pk
					? { ...kit, is_delivered_to: is_delivered } // Update the matching kit
					: kit // Keep the other kits unchanged
			}
			);
			const currentUser = currentProds[0].user
			const newSellerArray = {
				user: currentUser,
				kits: updatedKits
			}
			// dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
			// const updatedArray = currentProds.filter((data) => data.user.id !== kitData.user.id)
			const newArr = [...currentProdsToEdit, newSellerArray]
			dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
		}

		// Dispatch the action with the updated kit data
	};
};

export const updateSellersKitsDeliveredDate = (kitData, seller, delivered_date) => {
	return (dispatch, getState) => {
		// Access the current state
		const state = getState();

		// Log for debugging
		const currentProds = state.products.sellersKits.filter((data) => data.user.id === seller.user.id)
		const currentProdsToEdit = state.products.sellersKits.filter((data) => data.user.id !== seller.user.id)

		if (currentProds.length === 0) {
			console.log('not find userKit')
		} else {
			// console.log('currentKits:', currentProds)
			const updatedKits = currentProds[0].kits.map((kit) => {
				return kit.kit_pk === kitData.kit_pk
					? { ...kit, delivered_date: delivered_date } // Update the matching kit
					: kit // Keep the other kits unchanged
			}
			);
			const currentUser = currentProds[0].user
			const newSellerArray = {
				user: currentUser,
				kits: updatedKits
			}
			// dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
			// const updatedArray = currentProds.filter((data) => data.user.id !== kitData.user.id)
			const newArr = [...currentProdsToEdit, newSellerArray]
			dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
		}

		// Dispatch the action with the updated kit data
	};
};

export const updateSellersKitsIsPaidData = (kitData, seller, isPaid) => {
	// console.log('seller: ', seller)
	return (dispatch, getState) => {
		// Access the current state
		const state = getState();

		// Log for debugging
		const currentProds = state.products.sellersKits.filter((data) => data.user.id === seller.id)
		const currentProdsToEdit = state.products.sellersKits.filter((data) => data.user.id !== seller.id)

		if (currentProds.length === 0) {
			console.log('not find userKit')
		} else {
			// console.log('currentKits:', currentProds)
			const updatedKits = currentProds[0].kits.map((kit) => {
				return kit.kit_pk === kitData.kit_pk
					? { ...kit, is_paid: isPaid } // Update the matching kit
					: kit // Keep the other kits unchanged
			}
			);
			const currentUser = currentProds[0].user
			const newSellerArray = {
				user: currentUser,
				kits: updatedKits
			}
			// dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
			// const updatedArray = currentProds.filter((data) => data.user.id !== kitData.user.id)
			const newArr = [...currentProdsToEdit, newSellerArray]
			dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
		}

		// Dispatch the action with the updated kit data
	};
};

export const updateSellersKitsIsFailureChanged = (kitData, seller, failureToPay, paymentData) => {
	// console.log('update seller failure to Pay: ', seller)
	return (dispatch, getState) => {
		// Access the current state
		const state = getState();

		// Log for debugging
		const currentProds = state.products.sellersKits.filter((data) => data.user.id === seller.id)
		const currentProdsToEdit = state.products.sellersKits.filter((data) => data.user.id !== seller.id)
		const currentSellerToEdit = state.sellers.sellers.find((sellerState) => sellerState.id === seller.id)


		if (currentProds.length === 0) {
			console.log('not find userKit')
		} else {

			let failureArr = currentSellerToEdit?.kits_inadimplentes || []
			// console.log('currentKits:', currentProds)
			const updatedKits = currentProds[0].kits.map((kit) => {
				if (kit.kit_pk !== kitData.kit_pk) {
					return kit; // não é o kit alvo, mantém como está
				}

				// Só atualiza se for diferente
				if (kit.failure_to_pay !== failureToPay) {
					// console.log('oldKit', kit)
					// console.log('oldSeller', currentSellerToEdit)
					// console.log('oldSeller', failureArr)

					if (!failureToPay) {
						failureArr = failureArr.filter((data) => data.pk !== kitData.kit_pk)
					} else {
						const newObj = {
							seller__nome: seller.nome,
							kit_number: kit.kit_number,
							seller__pk: seller.id,
							pay_date: kit.pay_date,
							pk: kitData.kit_pk,
							osb_failure_to_pay: kit?.osb_failure_to_pay || '',
							total_value_sold: paymentData?.sale,
							total_paid_value: paymentData?.alreadyPaid
						}
						failureArr = [...failureArr, newObj]
						//gerar novo array incluindo o novo objeto
					}
					return { ...kit, failure_to_pay: failureToPay };
				}

				return kit; // mesmo valor, não muda nada
			});

			const updatedSeller = { ...currentSellerToEdit, kits_inadimplentes: failureArr }
			// console.log('newSeller: ', updatedSeller)
			const whitoutSellerToEdit = state.sellers.sellers.filter((sellerState) => sellerState.id !== seller.id)
			const newSellersArr = [...whitoutSellerToEdit, updatedSeller]

			dispatch(createAction(SELLERS_ACTIONS_TYPES.SET_SELLERS, newSellersArr))
			const currentUser = currentProds[0].user
			const newSellerArray = {
				user: currentUser,
				kits: updatedKits
			}
			// dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
			// const updatedArray = currentProds.filter((data) => data.user.id !== kitData.user.id)
			const newArr = [...currentProdsToEdit, newSellerArray]
			dispatch(createAction(PRODUCTS_ACTIONS_TYPES.SET_SELLERS_KIT, newArr));
		}

		// Dispatch the action with the updated kit data
	};
};